import React from 'react';
import GeneralInfoRender from '../../components/GeneralInfoRender'
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { changeClass, yearChange } from '../../actions'
import { pathOr } from 'ramda';

class GeneralInfo extends React.Component {

  state = {
    category: "All",
    cluster: "All",
    skill: "All"
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      let menulocation = this.props.location.pathname.split("/")[1]
      if (menulocation == 'school') {
        this.props.changeClass('All')
      }
    }
  }


  setFilter = (filterBy, selected) => {
    if (filterBy == 'category') {
      this.setState({category: selected})
    } else if (filterBy == 'cluster') {
      this.setState({cluster: selected})
    } else {
      this.setState({skill: selected})
    }
  }

  render() {

    let toptrackers = [];
    let raw_skillslogged = [0,0,0,0,0,0,0,0,0,0,0,0,0]
    let skillslogged = []
    // Get students from the same school as the teacher who is logged in
    let students = this.props.students;

    if (this.props.logs && students) {

      let logs = Object.entries(this.props.logs)
      //Create an object with logs/student
      let logsPerStudent = {}
      //If class is selected top trackers is filtered for that class, otherwise all students from school
      let filteredStudents;
      if (this.props.selectedClass && this.props.classes && this.props.selectedClass.id !== 'All') {
        let studentsInClass = []
        if (this.props.selectedClass.students) {
          studentsInClass = this.props.selectedClass.students
        }
        filteredStudents = students.filter( student =>
          studentsInClass.includes(student[0])
        )
      } else {
        filteredStudents = students
      }
      filteredStudents.map( student =>
        {
          let logsOfStudent;
          if (this.props.selectedClass && this.props.selectedClass.id !== 'All') {

             logsOfStudent = logs.filter( (log, i) =>
              log[1].user_id == student[0]
              &&
              log[1].subject.id == this.props.selectedClass.subjectId
            )
          } else {
             logsOfStudent = logs.filter( (log, i) =>
              log[1].user_id == student[0]
            )
          }


          let logsCount = logsOfStudent.length
          let objectKey = student[1].profile.name+' '+ student[1].profile.last_name
          // if (objectKey.length > 13 ) {
          //   objectKey = objectKey.slice(0, 10)+'...'
          // }
          logsPerStudent[objectKey] = logsCount
        }
      )

      //Sort them and keep the first 5
      let sort_logsPerStudent = [];
      for (let student in logsPerStudent) {
        sort_logsPerStudent.push([student, logsPerStudent[student]]);
      }
      sort_logsPerStudent.sort(function(a, b) {
        return b[1] - a[1];
      });
      sort_logsPerStudent = sort_logsPerStudent.slice(0,5)

      //Create an array of objects
      sort_logsPerStudent.map( (value, i) => {
        toptrackers.push({
          name: value[0],
          value: value[1]
        })
      })

      //Filter based on selected student
      if (this.props.studentFilter.id != 'all') {
        logs = logs.filter( log =>
          log[1].user_id == this.props.studentFilter.id
        )
      }

      if (this.state.category != 'All') {
        logs = logs.filter( log =>
          log[1].atl_category.name == this.state.category
        )
        if (this.state.cluster != 'All') {
          logs = logs.filter( log =>
            log[1].atl_cluster.name == this.state.cluster
          )
          // if (this.state.skill != 'All') {
          //   logs = logs.filter( log =>
          //     log[1].skill.name == this.state.skill
          //   )
          // }
        }
      }
      //Find out which years and months are the logs from
      logs  && logs.map( (log, i) => {
        let month = log[1].date.split("-")[1]
        if (month.charAt(0) == '0') {
          month = month.slice(1,2)
        }
        raw_skillslogged[month]++

      })


      if (this.props.currentYear.year && this.props.currentYear.year.text.includes(' - ')) {
        skillslogged = [
          { name: 'Aug', value: raw_skillslogged[8] },
          { name: 'Sept', value: raw_skillslogged[9] },
          { name: 'Oct', value: raw_skillslogged[10] },
          { name: 'Nov', value: raw_skillslogged[11] },
          { name: 'Dec', value: raw_skillslogged[12] },
          { name: 'Jan', value: raw_skillslogged[1] },
          { name: 'Feb', value: raw_skillslogged[2] },
          { name: 'Mar', value: raw_skillslogged[3] },
          { name: 'Apr', value: raw_skillslogged[4] },
          { name: 'May', value: raw_skillslogged[5] },
          { name: 'Jun', value: raw_skillslogged[6] },
          { name: 'Jul', value: raw_skillslogged[7] }
        ]
      } else {
        skillslogged = [
          { name: 'Jan', value: raw_skillslogged[1] },
          { name: 'Feb', value: raw_skillslogged[2] },
          { name: 'Mar', value: raw_skillslogged[3] },
          { name: 'Apr', value: raw_skillslogged[4] },
          { name: 'May', value: raw_skillslogged[5] },
          { name: 'Jun', value: raw_skillslogged[6] },
          { name: 'Jul', value: raw_skillslogged[7] },
          { name: 'Aug', value: raw_skillslogged[8] },
          { name: 'Sept', value: raw_skillslogged[9] },
          { name: 'Oct', value: raw_skillslogged[10] },
          { name: 'Nov', value: raw_skillslogged[11] },
          { name: 'Dec', value: raw_skillslogged[12] },
        ]
      }
    }

    //Total logs per school
    let logsCount;
    if (this.props.profile && students) {
      let studentIds = [];
      //Put school's student's id-s into an array
      students.map( student => studentIds.push(student[0]))
      logsCount = this.props.logs && Object.entries(this.props.logs)
      if (logsCount) {
        logsCount = logsCount.length
      } else {
        logsCount = 0
      }


    }

    //Filter graph by category/cluster/skills
    let category;
    let cluster;
    let skill;
    if (this.props.category && this.props.cluster && this.props.skill) {
      category = Object.entries(this.props.category)
      cluster = Object.entries(this.props.cluster)

      // Find the ID of selected category
      let categoryId;
      if (this.state.category && this.state.category != 'All') {
        categoryId = category.filter( category =>
          category[1].name == this.state.category
        )
        categoryId = (categoryId && categoryId.length !== 0) && categoryId[0][0]
      }


      cluster = cluster.filter( cluster =>
          cluster[1].category == categoryId
          //cluster[1].category == this.state.category

        &&
        cluster[1].readOnly == false
      )
      skill = Object.entries(this.props.skill)
        .map( skill =>
          skill[1].name
        )
    }

    return (
      <GeneralInfoRender
        toptrackers={toptrackers}
        skillslogged={skillslogged}
        t={this.props.t}
        logsCount={logsCount}
        category={category}
        cluster={cluster}
        allClusters={this.props.cluster}
        skill={skill}
        setFilter={(filterBy, selected) => this.setFilter(filterBy, selected)}
        currentYear={this.props.currentYear}
        changeYear={this.props.changeYear}
        allYears={this.props.allYears}
        allLogs={this.props.allLogs}
        allStudents={this.props.allStudents}
        classes={this.props.classes}
        gradeSelected={this.props.gradeSelected}
      />
    )
  }
}

function mapDispatchToProps(dispatch) {
    return({
        changeClass: (id, subject, name, grade) => {dispatch(changeClass(id, subject, name, grade))},
        changeYear: (year) => {dispatch(yearChange(year))}
    })
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'users', 'atl_category', 'atl_cluster', 'skills', 'students','profile'
    ]
  }),
  connect(
    state => {
      const schoolId = pathOr(null, ['profile', 'profile', 'school', 'id'], state.firebase)
      return {
        users: state.firebase.data.users,
        studentFilter: state.studentFilter,
        logs: state.relevantLogs.logs,
        allLogs: state.firebase.data.logs,
        allStudents: state.studentsOfSchool.students,
        category: state.firebase.data.atl_category || {},
        cluster: state.firebase.data.atl_cluster || {},
        skill: state.firebase.data.skills || {},
        students: state.studentsOfSchool.students,
        profile: state.firebase.profile,
        selectedClass: state.selectedClass,
        classes: pathOr(null,['data', 'schools', schoolId, 'classes'], state.firebase),
        currentYear: state.currentYear,
        allYears: state.allYears && state.allYears.years,
        gradeSelected: state.selectedClass.id == 'All' ? false : true
      }},
      mapDispatchToProps
  )
)
export default enhancer(GeneralInfo);



// WEBPACK FOOTER //
// ./src/containers/GeneralInfo/index.jsx